const initialState = {
  badgesList: [],
};

export const badgesReducer = (state = initialState, action) => {
  if (typeof action.execute === "function" && action.type === "badges")
    return action.execute(state);
  return state;
};
